import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { RestClientService } from '../services/restclient.service';
import { MensagemService } from '../services/mensagem.service';
import { SegundaViaService } from '../services/segundavia.service';
import { SegundaViaContrato } from '../modelo/segundaViaContrato';
import { Contrato } from '../modelo/contrato';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var $: any;

@Component({
  selector: 'app-segundaviacarne-modal-endereco',
  templateUrl: './segundaviacarne-modal-endereco.component.html',
  styleUrls: ['./segundaviacarne.component.css'],
  providers: [SegundaViaService, MensagemService, RestClientService]
})
export class SegundaViaCarneModalEnderecoComponent extends AbstractComponent implements OnInit {

  contrato: Contrato;

  constructor(
    private segundaViaService: SegundaViaService,
    private mensagemService: MensagemService,
    private router: Router,
    private sessaoService: SessaoService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SegundaViaCarneModalEnderecoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
  }

  ngOnInit() {
    setTimeout(function () {
      $('.cdk-global-overlay-wrapper').css({ 'align-items': "flex-end" });
    }, 0);
    this.contrato = this.data.contrato;
  }

  confirmar() {
    this.fechar();
    this.segundaViaService.solicitarSegundaViaCarne(
      this.contrato
    ).subscribe(
      (result: SegundaViaContrato) => {
        sessionStorage.setItem("segundaViaContrato",JSON.stringify(result));
        this.router.navigate(['/BF-Portal/segundaviacarneConclusao']);
        this.fechar();
      },
      (error: Response) => {
        this.fechar();
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Fecha a modal
   */
  fechar() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-segundaviacarne-cli/segundaviacarne-modal-endereco.component.ts